import { getPropsForClickTracking } from "../../utils/tracking";
$ const { button, tourtip } = input.marker || {};
$ const { placement } = state;
$ const overlayRadius = input.overlayRadius || 0;
$ const { messageDismiss, messageText, bubbleIcon } = tourtip || {};

<div class="map-user-location-marker-wrapper">
  <div class="user-location-marker" data-testid="user-location-marker"/>
  <if(overlayRadius)>
    <div
      class="walking-distance-overlay"
      data-testid="walking-distance-overlay"
      style=`top: -${state.overlayPositionOffset}px; left: -${state.overlayPositionOffset}px;`
    >
      <div class="walking-overlay-circle" data-testid="walking-overlay-circle" style=`width: ${overlayRadius}px; height: ${overlayRadius}px;`/>
      <div on-keydown("onKeyDownHandler") on-click("openTourtip") class="walking-overlay-label" data-testid="walking-overlay-label">
        <ebay-tourtip
          a11yCloseText=(messageDismiss?.textSpans?.[0].text)
          ariaLabel=bubbleIcon?.accessibilityText
          open=state.isTourtipOpen
          placement=placement
          noFlip
          onCollapse("onTourtipClose")
        >
          <@host>
            <ebay-button
              class="overlay-label-button button"
              size="small"
              priority="primary"
              ...getPropsForClickTracking(button?.action?.trackingList)
            >
              <include-html("./svg/walking.svg")/>
              ${button?.text}
            </ebay-button>
          </@host>
          <@content>
            <p>
              <fe-textual-display model=messageText?.[0]/>
            </p>
          </@content>
        </ebay-tourtip>
      </div>
    </div>
  </if>
</div>
